<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-watch`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M28.578 2c1.026 0 2.064.895 2.317 2l1.652 7.201A6.002 6.002 0 0137 17v14a6.003 6.003 0 01-4.452 5.798L30.895 44c-.253 1.105-1.29 2-2.317 2H17.422c-1.027 0-2.065-.895-2.318-2l-1.653-7.202A6.003 6.003 0 019 31V17a6.002 6.002 0 014.453-5.799L15.105 4c.253-1.105 1.29-2 2.317-2h11.155zm-.181 35H17.603l1.147 5h8.5l1.147-5zM15 15h16a2 2 0 012 2v14a2 2 0 01-2 2H15a2 2 0 01-2-2V17a2 2 0 012-2zm27 5a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1h2zM18.75 6h8.5l1.147 5H17.603l1.147-5z"/></svg>
</template>
<script>

export default {
  name: 'IconWatch',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
